import { render, staticRenderFns } from "./SetupPassword.vue?vue&type=template&id=70a56920"
import script from "./SetupPassword.vue?vue&type=script&lang=js"
export * from "./SetupPassword.vue?vue&type=script&lang=js"
import style0 from "./SetupPassword.vue?vue&type=style&index=0&id=70a56920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports